<template>
  <div>
    <WsDialog
      v-model="dialog"
      ref="WsDialog"
      @close="$_handleDialogClose()"
      :title="`匯入檔案`"
    >
      <template v-slot:content>
        <ValidationObserver ref="form">
          <v-form
            ref="createForm"
            @submit.prevent
          >
            <WsStateLocales
              v-if="_localeField&&dialog"
              :fields="_localeField.fields"
              :value="importData[_localeFieldKey]"
              @input="$_onInput(_localeFieldKey,$event)"
            ></WsStateLocales>
            <v-row>
              <v-col
                v-for="(field, fieldKey) in _generalFields"
                cols="12"
                :sm="field.sm ? field.sm : 12"
                :key="fieldKey"
              >
                <WsState
                  v-if="dialog"
                  :type="field.type"
                  :label="field.label"
                  :fields="field.fields"
                  :rules="field.rules"
                  :items="field.items"
                  :modelName="field.modelName"
                  :textKey="field.textKey"
                  :uploadUrl="field.uploadUrl"
                  :note="field.note"
                  :maxWidth="field.maxWidth"
                  :autofocus="field.autofocus"
                  :parent="field.parentKey"
                  :parentState="$_getParentState(fieldKey,fields)"
                  :requiredField="field.requiredField"
                  :displayLabel="field.displayLabel"
                  :excludeSelf="field.excludeSelf"
                  :maxlength="field.maxlength"
                  :value="importData[fieldKey]"
                  :parentStateName="field.parentStateName"
                  :accept="field.accept"
                  :errorMessage="$_getErrorMessage(fieldKey)"
                  @input="$_onInput(fieldKey,$event)"
                  @import-file="$_onImportFile($event, field.uploadUrl)"
                />
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </template>
      <template v-slot:rightActions>
        <!-- <WsBtn
          @click="$_onCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >返回</WsBtn> -->
        <WsBtn
          @click="$_onCancel()"
          minWidth="100px"
          color="textSecondary"
          outlined
        >取消</WsBtn>
        <WsBtn
          @click="$_onSubmit()"
          minWidth="100px"
          :loading="submitLoading"
          color="primary"
        >送出</WsBtn>
      </template>
    </WsDialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    importData: {},
    submitLoading: false,
    dialog: false,
    formData: null,
    uploadUrl: null
  }),
  methods: {
    $_getErrorMessage(fieldKey) {
      if (this.errorMessages) {
        if (this.errorMessages[fieldKey]) {
          return this.errorMessages[fieldKey];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    $_handleDialogClose() {
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    $_keydownHandler(event) {
      if (event.metaKey && event.key == "Enter") {
        this.$_onSubmit();
      }
    },
    $_getParentState(fieldKey, modedFields) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, modedFields);
      if (field.parentKey) {
        return this.importData[field.parentKey];
      } else if (field.requiredField) {
        return this.importData[field.requiredField];
      } else {
        return null;
      }
    },
    $_onInput(fieldKey, $event) {
      this.importData[fieldKey] = $event;
      if (!$event) {this.formData = null}
    },
    stopLoading() {
      this.submitLoading = false;
    },
    startLoading() {
      this.submitLoading = true;
    },
    $_onCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      window.removeEventListener("keydown", this.$_keydownHandler);
      this.reset();
    },
    $_importDataSet(template, importData, fields) {
      for (let fieldKey in fields) {
        const field = fields[fieldKey];
        if (field.defaultValue !== undefined) {
          template.$set(importData, fieldKey, field.defaultValue);
        } else {
          template.$set(importData, fieldKey, null);
        }
      }
    },
    reset() {
      this.$refs.form.reset();
      this.submitLoading = false;
    },
    open() {
      this.$_CMS_updateDataSetFromFields(this, this.importData, this.fields);
      this.dialog = true;
      window.addEventListener("keydown", this.$_keydownHandler);
    },
    $_onImportFile($event, uploadUrl) {
      this.formData = $event
      this.uploadUrl = uploadUrl
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return;
      }
      this.$emit("create-submit", {formData: this.formData, uploadUrl: this.uploadUrl});
    }
  },
  computed: {
    _generalFields() {
      const _generalFields = {};
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          continue;
        }
        _generalFields[fieldKey] = field;
      }
      return _generalFields;
    },
    _localeField() {
      let _localeField = null;
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          _localeField = field;
        }
      }
      return _localeField;
    },
    _localeFieldKey() {
      let _localeFieldKey = null;
      for (let fieldKey in this.fields) {
        const field = this.fields[fieldKey];
        if (field.type == "locales") {
          _localeFieldKey = fieldKey;
        }
      }
      return _localeFieldKey;
    },
  },
  props: {
    errorMessages: {
      type: Object,
      default: null,
    },
    modelName: String,
    label: {
      type: String,
      default: null,
    },
    fields: Object,
  },
  watch: {
    dialog: {
      handler() {
        if (!this.dialog) {
          this.reset();
        }
      },
    },
  },
};
</script>

